<template>
	<v-layout>
		<v-flex sm12 md6>
			<p class="add-event-step-header mb-1">How many &amp; how much?</p>
			<p class="add-event-step-sub-header">Revenue helps our hosts provide great opportunities to maximize human potential again and again. The real value in hosting is the connections you’ll make. Keep this in mind as you think through your ideal price point.</p>
			<p class="add-event-step-secondary-header mb-1">Maximum number of guests</p>
			<p class="add-event-step-sub-header">How many guests can this event or experience accommodate?</p>

			<v-text-field color="link" id="seats" :error="!validSeats" class="pa-5 mb-2" :rules="[rules.seats]" v-model="seats" type="number" prepend-icon="fal fa-users"></v-text-field>

			<p class="add-event-step-secondary-header">Event ticket price</p>
			<p class="add-event-step-sub-header">The price of your experience is entirely up to you. We often recommend starting in the $5 - $15 range, but you’re welcome to go higher; especially if you’re planning something that brings extra value!</p>

			<v-text-field color="link" id="price" :error="!validPrice" class="pa-5 mb-2" v-model="price" type="number" :rules="[rules.price]" prepend-icon="fal fa-dollar-sign"></v-text-field>

			<span v-if="price !== 0">
				<p class="text-xs-center add-event-step-secondary-header mb-2">And just like that... a better workday for you,<br>and an easy extra</p>
				<p class="text-xs-center add-event-step-header mb-2"><span v-if="getAddEventProp('price') > -1 && validSeats === true">${{ totalEarnings }}</span></p>
				<p class="text-xs-center add-event-step-secondary-header mb-4">for your pocket.</p>
				<p class="text-xs-center add-event-step-sub-header">Earnings estimates are calculated as follows: Your event’s capacity multiplied by price, minus a {{ getHostFee * 100 }}% service fee.</p>
				<p class="text-xs-center add-event-step-sub-header">Learn more about wrkprty’s <a @click="openPaymentTerms">fees and Payment Structure</a></p>
			</span>

			<v-dialog v-model="seatingExampleDialog" max-width="500px">
				<v-card>
					<v-card-title class="mb-0 pb-2 pt-3">
						<img class="info-mobile-icon" src="/static/images/icon/light-bulb-gray.svg" />
					</v-card-title>
					<v-card-text>
						<p class="add-event-tip-title">Not sure how many guests you can fit?</p>
						<p class="add-event-tip-content">Take a look around your location and remember, some people really do prefer to sit on your couch, at the bar stool in your kitchen, or many other interesting places.</p>
						<p class="add-event-tip-content">Don’t be timid, pack ‘em in! The more guests you can accommodate the more it adds up for you, and frankly, the more enjoyable the experience will be for all.</p>
						<p class="add-event-tip-content">Remember, people have joined WRKPRTY for human connection. If all they wanted was a big private desk space, they’d just stay home or rent an office.</p>
						<p class="add-event-tip-content">And of course, there’s also this...</p>
						<p class="add-event-tip-content">Not everyone will show up. There’s always someone who has to change plans last minute.</p>
						<p class="add-event-tip-content">So go ahead, count the beanbag as a spot!</p>
					</v-card-text>
					<v-card-actions>
						<v-spacer>
						</v-spacer>
						<v-btn icon class="info-mobile-dialog-close-button" @click="infoDialog=false"><v-icon>close</v-icon></v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-flex>
<!-- 		<v-flex md4 offset-md1 hidden-sm-and-down class="pt-3">
			<v-card>
				<v-card-text style="height: 150px;">
					<p class="add-event-example-sub-header-light">Examples</p>
					<p class="add-event-example-sub-header">Guests: <span class="add-event-example-content">{{examples[exampleIndex].guests}}</span></p>
					<p class="add-event-example-sub-header">Price: <span class="add-event-example-content">{{examples[exampleIndex].price}}</span></p>
					<p class="add-event-example-sub-header">You Earn: <span class="add-event-example-content">{{examples[exampleIndex].result}}</span></p>
				</v-card-text>
				<v-card-actions>
					<p class="ml-3 add-event-example-content example-toggle-icon" style="display:inline;">Example {{exampleIndex+1}}/{{examples.length}}</p>
					<v-spacer></v-spacer>
					<v-btn small flat @click="lastExample"><v-icon class="example-toggle-icon">fa-chevron-left</v-icon></v-btn>
					<v-btn small flat @click="nextExample"><v-icon class="example-toggle-icon">fa-chevron-right</v-icon></v-btn>
				</v-card-actions>
			</v-card>
		</v-flex> -->
		<v-flex xs12 md4 offset-md1 hidden-sm-and-down class="pt-3">
			<v-card>
				<v-card-text class="p-relative pt-5">
					<div class="info-trapezoid p-absolute">
						<div class="info-content">
							<img src="/static/images/icon/light-bulb-gray.svg" width="40" />
						</div>
					</div>
					<p class="add-event-tip-title">Not sure how many guests you can fit?</p>
					<p class="add-event-tip-content">Take a look around your location and remember, some people really do prefer to sit on your couch, at the bar stool in your kitchen, or many other interesting places.</p>
					<p class="add-event-tip-content">Don’t be timid, pack ‘em in! The more guests you can accommodate the more it adds up for you, and frankly, the more enjoyable the experience will be for all.</p>
					<p class="add-event-tip-content">Remember, people have joined WRKPRTY for human connection. If all they wanted was a big private desk space, they’d just stay home or rent an office.</p>
					<p class="add-event-tip-content">And of course, there’s also this...</p>
					<p class="add-event-tip-content">Not everyone will show up. There’s always someone who has to change plans last minute.</p>
					<p class="add-event-tip-content">So go ahead, count the beanbag as a spot!</p>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-dialog scrollable v-model="infoDialog">
			<v-card style="width: 100%">
				<v-card-title class="mb-0 pb-2 pt-3">
					<img class="info-mobile-icon" src="/static/images/icon/light-bulb-gray.svg" />
				</v-card-title>
				<v-card-text style="max-height:50vh;">
					<p class="add-event-tip-title">Not sure how many guests you can fit?</p>
					<p class="add-event-tip-content">Take a look around your location and remember, some people really do prefer to sit on your couch, at the bar stool in your kitchen, or many other interesting places.</p>
					<p class="add-event-tip-content">Don’t be timid, pack ‘em in! The more guests you can accommodate the more it adds up for you, and frankly, the more enjoyable the experience will be for all.</p>
					<p class="add-event-tip-content">Remember, people have joined WRKPRTY for human connection. If all they wanted was a big private desk space, they’d just stay home or rent an office.</p>
					<p class="add-event-tip-content">And of course, there’s also this...</p>
					<p class="add-event-tip-content">Not everyone will show up. There’s always someone who has to change plans last minute.</p>
					<p class="add-event-tip-content">So go ahead, count the beanbag as a spot!</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer>
					</v-spacer>
					<v-btn icon class="info-mobile-dialog-close-button" @click="infoDialog=false"><v-icon>close</v-icon></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- <div class="mb-3 add-event-step-info-link" @click="seatingExampleDialog=true"><v-icon class="add-event-step-info-icon">fa-info-circle</v-icon> Tips</div> -->
	</v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
	data() {
		return {
			exampleIndex: 0,
			examples: [
				{ guests: '10', price: '$20', result: '$140' },
				{ guests: '20', price: '$15', result: '$180' },
				{ guests: '15', price: '$15', result: '$135' }
			],
			paymentInfoDialog: false,
			seatingExampleDialog: false,
			validSeats: false,
			validPrice: false,
			rules: {
				seats: value => {
					if (
						(value >= 5 || value === null) &&
						value <= this.getAddEventProp('maxSeats')
					) {
						this.validSeats = true
						return true
					} else if (value > this.getAddEventProp('maxSeats')) {
						this.validSeats = false
						return (
							'This location does not allow more than ' +
							this.getAddEventProp('maxSeats') +
							' attendees'
						)
					} else {
						this.validSeats = false
						return 'This event must have 5 or more attendees'
					}
				},
				price: value => {
					if (value >= 5 || value === null) {
						this.validPrice = true
						return true
					}
					this.validPrice = false
					return 'Price must be equal or greater than $5'
				}
			}
		}
	},
	beforeRouteLeave(to, from, next) {
		if (![this.seats, this.price].includes(null)) {
			if (
				this.validSeats &&
				(this.validPrice && this.getAddEventProp('price'))
			) {
				this.setAddEventValidStep(from.path)
				this.removeAddEventInvalidStep(from.path)
			} else {
				this.removeAddEventValidStep(from.path)
				this.setAddEventInvalidStep(from.path)
			}
		} else {
			this.removeAddEventValidStep(from.path)
			this.setAddEventInvalidStep(from.path)
		}
		next()
	},
	methods: {
		...mapActions([
			'setModalOpen',
			'setTermsPage',
			'setAddEventValidStep',
			'removeAddEventValidStep',
			'setAddEventInvalidStep',
			'removeAddEventInvalidStep',
			'setAddEventProp'
		]),
		openPaymentTerms() {
			this.setModalOpen({ prop: 'termsModal', value: true })
			this.setTermsPage('paymentpolicy')
		},
		lastExample() {
			this.exampleIndex -= 1
			if (this.exampleIndex < 0) {
				this.exampleIndex = this.examples.length - 1
			}
		},
		nextExample() {
			this.exampleIndex += 1
			if (this.exampleIndex >= this.examples.length) {
				this.exampleIndex = 0
			}
		}
	},
	computed: {
		...mapGetters(['getAddEventProp', 'getHost', 'user']),
		seats: {
			get() {
				return this.getAddEventProp('seats')
			},
			set(val) {
				this.setAddEventProp({ prop: 'seats', value: val })
			}
		},
		price: {
			get() {
				return this.getAddEventProp('price')
			},
			set(val) {
				this.setAddEventProp({ prop: 'price', value: val })
			}
		},
		realTicketPrice() {
			if (this.getAddEventPrice > 0) {
				return this.getAddEventPrice - 6
			}
		},
		getHostFee() {
			let hostFee
			if (this.getHost.hasOwnProperty('override_percentage')) {
				hostFee = this.getHost.override_percentage
			} else if (this.user.groups.find(group => group.name === 'host-free')) {
				hostFee = 0.0
			} else {
				hostFee = 0.15
			}
			return hostFee
		},
		totalEarnings() {
			return parseFloat(
				this.getAddEventProp('price') *
					(1.0 - this.getHostFee) *
					this.getAddEventProp('seats')
			).toFixed(2)
		},
		serviceFees() {
			return parseFloat(
				this.getHostFee *
					this.getAddEventProp('price') *
					this.getAddEventProp('seats')
			).toFixed(2)
		},
		infoDialog: {
			get() {
				return this.getAddEventProp('infoDialog')
			},
			set(val) {
				this.setAddEventProp({ prop: 'infoDialog', value: val })
			}
		}
	}
}
</script>

<style>
</style>
